import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { UserService } from '../../../service/user/user.service';
import { CommonService } from '../../../service/common/common.service';
import { RoleService } from '../../../service/role/role.service';
import { LogicalwhService } from '../../../service/logicalwh/logicalwh.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9004.component.html',
  styleUrls: ['wa9004.component.css']
})
export class Wa9004Component implements AfterViewInit {
  public componentTitle = 'WA9004:ユーザマスタパスワード更新';

  public logicalWhs: any;
  public roles: any;

  private userId: string;
  public userCd: string;
  public userTx: string;
  public langTx = 'ja';
  public passwordTx: FormControl;
  public roleId = 2;
  public logicalWhId: number;

  public validation = validation;

  public working = false;
  public height = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(private router: Router, private userService: UserService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.userId = sessionStorage.getItem('userpasswd');

    // パスワード
    this.passwordTx = new FormControl(this.passwordTx, [Validators.required, Validators.pattern(validation.password)]);

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.height = window.innerHeight - 80;
  }

  onResize(event) {
    this.height = event.target.innerHeight - 80;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    if (this.userId === null) {
      this.router.navigate([
        JSON.parse(sessionStorage.getItem('loginResult')).user.roleId === 3  
        ? 'wa0003' : 'wa0002']);;
      return;
    }

    const args = 'userId=' + this.userId;

    this.working = true;

    this.userService
      .get(args)
      .then(outputJson => {
        this.working = false;
        console.log(JSON.stringify(outputJson));

        // ユーザーコード
        this.userCd = outputJson.users[0].userCd;
        // ユーザ名
        this.userTx = outputJson.users[0].userTx;
        // ロールID
        this.roleId = outputJson.users[0].roleId;
        // 論理倉庫ID
        this.logicalWhId = outputJson.users[0].logicalWhId;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    let errors = false;
    if (this.passwordTx.errors !== null) {
      this.passwordTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    this.working = true;
    this.userService
      .password(this.userId, this.passwordTx.value)
      .then(outputJson => {
        this.working = false;
        this.router.navigate(['wa9001']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.router.navigate(['wa9001']);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9004/wa9004.component.ts